const getDate = (time, fuzzy) => {
    if (fuzzy) {
        const date = new Date(Date.parse(time));
        const now = new Date();

        // check if date is valid
        if (isNaN(date)) {
            return time;
        }

        const deltaMilliseconds = now - date;
        const deltaSeconds = Math.floor(deltaMilliseconds / 1000);
        const deltaMinutes = Math.floor(deltaSeconds / 60);
        const deltaHours = Math.floor(deltaMinutes / 60);

        if (deltaSeconds < 5) {
            return "zojuist";
        } else if (deltaSeconds < 60) {
            return deltaSeconds + " seconden geleden";
        } else if (deltaMinutes == 1) {
            return "1 minuut geleden";
        } else if (deltaMinutes < 60) {
            return deltaMinutes + " minuten geleden";
        } else if (deltaHours == 1) {
            return "1 uur geleden";
        } else if (deltaHours < 6) {
            return deltaHours + " uren geleden";
        } else if (deltaHours > 24) {
            return Math.floor(deltaHours / 24) + " dagen geleden";
        } else {
            return new Date(time).toLocaleString("nl-NL", {
                day: "numeric",
                month: "long",
                year: "numeric",
            });
        }
    }

    return new Date(time).toLocaleString("nl-NL", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
};

export default getDate;
